import { render, staticRenderFns } from "./PubBox.vue?vue&type=template&id=a0641232&scoped=true&"
import script from "./PubBox.vue?vue&type=script&lang=js&"
export * from "./PubBox.vue?vue&type=script&lang=js&"
import style0 from "./PubBox.vue?vue&type=style&index=0&id=a0641232&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0641232",
  null
  
)

export default component.exports